// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7538":"2609228f","7886":"2609228f","9120":"4b774b07","9471":"2609228f"}[chunkId] + ".chunk.css";
};